import thumbnail from './thumbnail.png';
import Mediator from './Mediator';

export default {
    handle: 'poiseCourseRegistration',
    label: 'POISE Course Registration',
    thumbnail,
    mediatorComponent: Mediator,
};
